export default {
    SET_DATA_DASHBOARD(state, payload) {
      state.dataDashBoard = payload
    },
    SET_LIST_TYPE_DASHBOARD(state, payload) {
      state.listTypeDashBoard = payload
    },
    SET_LIST_USER_DASHBOARD(state, payload) {
      state.listUserDashBoard = payload
    },
    SET_LIST_OPTIONS_DASHBOARD(state, payload) {
      state.listOptionsDashBoard = payload;
  },
  }